import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type TrainingView = "admin" | "agent";

export type ChatMessage = {
    id: string;
    role: "user" | "coach";
    text: string;
    at: number;
};

type TrainingState = {
    view: TrainingView;
    /** Ask Your Coach thread — intentionally not persisted; resets on reload. */
    chat: ChatMessage[];
};

const initialState: TrainingState = {
    view: "agent",
    chat: [],
};

const trainingSlice = createSlice({
    name: "training",
    initialState,
    reducers: {
        setView(state, action: PayloadAction<TrainingView>) {
            state.view = action.payload;
        },
        sendCoachMessage(state, action: PayloadAction<Omit<ChatMessage, "id" | "at">>) {
            state.chat.push({
                id: `msg-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
                at: Date.now(),
                ...action.payload,
            });
        },
        clearChat(state) {
            state.chat = [];
        },
    },
});

export const { setView, sendCoachMessage, clearChat } = trainingSlice.actions;
export default trainingSlice.reducer;
